import React, {
  FunctionComponent,
  useEffect,
  useState,
  useRef,
} from "react";
import styles from "../BulkEditModal/BulkEditModal.module.css";
import Modal from "react-modal";
import { IoIosClose } from "react-icons/io";

import Dropdown from "../../DropDown/Dropdown";
import {
  addNoteFirebase,
  contactResources,
  createTaskFirebase,
  createTaskMongo,
  fetchConstants,
  fetchpropertySubType,
  validateInterested,
  addNoteMongo,
  contactResourcesMongo
} from "../../../Services/contacts";
import { connect, useDispatch } from "react-redux";
import Loading from "../../Loading/Loading";
import TextInput from "../../TextInput/TextInput";
import { FaUser } from "react-icons/fa";
import moment from "moment";
import { useHistory, useLocation } from "react-router-dom";
import {themeColors} from "../../theme";
import Label from "../../Label";
import { motion,AnimatePresence } from "framer-motion";
import Backdrop from "../../Backdrop/Backdrop";
import { propertyStage } from "../../../Values/constants";
import { getLocationData } from "../../../Services/resources";
import DropDownWithDisplayName from "../../DropDown/DropDownWithDisplayName";

type props = {
  contactDetail: any;
  close: () => void;
  open: boolean;
  notes: any[];
  tasksData: any[];
  user: any;
  theme:any;
  authToken:any;
  organizationData:any;
  constants:any, 
  organizationResources:any
  mbConstants:any
};


const dropIn = {
  hidden: {
    y: "-100vh",
    opacity: 1,
  },
  visible: {
    y: "0",
    opacity: 1,
    transition: {
      duration: 1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
};

const InterestedLeadModal: FunctionComponent<props> = ({
  contactDetail,
  close,
  open,
  notes,
  tasksData,
  user,
  theme,
  authToken,
  organizationData,
  constants,
  organizationResources,
  mbConstants
}) => {
  const Requirement=[
    "NEW PROJECT",
    "RENTAL",
    "RESALE"
  ];

  const firstNameRef: any = useRef();
  const lastNameRef: any = useRef();
  const dateRef: any = useRef();
  const noteRef: any = useRef();
  const alternateRef: any = useRef();
  const [load, setLoad] = useState(false);
  const [projectSelected, setProjectSelected] =
    useState<any>({
      label: contactDetail.project
        ? contactDetail.project
        : "Select",
      value: contactDetail.project
        ? contactDetail.project
        : "Select",
    });

  const [locationSelected, setlocationSelected] =
    useState<any>({
      label: contactDetail.location
        ? contactDetail.location
        : "Select",
      value: contactDetail.location
        ? contactDetail.location
        : "Select",
    });
    const [stateSelected, setStateSelected] =
    useState<any>({
      label: contactDetail.state
        ? contactDetail.state
        : "Select",
      value: contactDetail.state
        ? contactDetail.state
        : "Select",
    });
    const [requirement_Type, setRequirement_Type] = useState<any>({
      label: contactDetail.requirement_Type
      ? contactDetail.requirement_Type
      :"Select",
      value: contactDetail.requirement_Type
      ? contactDetail.requirement_Type
      :"Select",
    });
  const [budgetSelected, setBudgetSelected] = useState<any>(
    {
       label: contactDetail?.display_budget? contactDetail.display_budget: contactDetail.budget? contactDetail.budget: "Select",
      value: contactDetail.budget
        ? contactDetail.budget
        : "Select",
    }
  );
  const [propertyTypeSelected, setPropertyTypeSelected] =
    useState<any>({
      label: contactDetail.property_type
        ? contactDetail.property_type
        : "Select",
      value: contactDetail.property_type
        ? contactDetail.property_type
        : "Select",
    });
  const [propertyStageSelected, setPropertyStageSelected] =
    useState<any>({
      label: contactDetail.property_stage
        ? contactDetail.property_stage
        : "Select",
      value: contactDetail.property_stage
        ? contactDetail.property_stage
        : "Select",
    });
  const [nextFollowSelected, setNextFollowSelected] =
    useState<any>({
      label: contactDetail.next_follow_up_type
        ? contactDetail.next_follow_up_type
        : "Select",
      value: contactDetail.next_follow_up_type
        ? contactDetail.next_follow_up_type
        : "Select",
    });
  const [
    propertySubTypeSelected,
    setPropertySubTypeSelected,
  ] = useState<any>({
    label: contactDetail.property_sub_type
      ? contactDetail.property_sub_type
      : "Select",
    value: contactDetail.property_sub_type
      ? contactDetail.property_sub_type
      : "Select",
  });
  const [leadSourceSelected, setLeadSourceSelected] =
    useState<any>({
      label: contactDetail.lead_source
        ? contactDetail.lead_source
        : "Select",
      value: contactDetail.lead_source
        ? contactDetail.lead_source
        : "Select",
    });
    const [businessVerticalSelected, setBusinessVerticalSelected] =
    useState<any>({
      label: "Select",
      value: "Select",
    });

  const [projectsList, setProjectsList] = useState<any[]>(
    []
  );
  const [locationsList, setLocationsList] = useState<any[]>(
    []
  );
  const [stateList, setStateList] = useState<any[]>(
    []
  );
  const [budgetsList, setBudgetsList] = useState<any[]>([]);
  const [propertyTypeList, setPropertyTypeList] = useState<
    any[]
  >([]);
  const [propertyStageList, setPropertyStageList] =
    useState<any[]>([]);
  const [nextFollowUpList, setnextFollowUpList] = useState<
    any[]
  >([]);
  const [notIntReasonList, setNotIntReasonList] = useState<
    any[]
  >([]);
  const [lostReasonList, setLostReasonList] = useState<
    any[]
  >([]);
  const [comTypes, setComTypes] = useState<any[]>([]);
  const [resTypes, setResTypes] = useState<any[]>([]);
  const [propertySubType, setPropertySubType] = useState<
    any[]
  >([]);
  const [leadSourceList, setLeadSourceList] = useState<
    any[]
  >([]);
  const [businessVerticalList, setBusinessVerticalList] = useState<any[]>(
    []
  );
const [constantBudget, setConstantBudget] = useState<any[]>(mbConstants?.buyBudget?mbConstants?.buyBudget:[]);
  const [industrialTypes, setIndustrialTypes] = useState<any[]>([]);
    const [institutionalTypes, setInstitutionalTypes] = useState<any[]>([]);

  // const propertyStageList:any=[];
  // Object.keys(propertyStage).forEach((key)=>{
  //   propertyStageList.push(propertyStage[key])
  // })

    useEffect(() => {
      if (requirement_Type.value === "RENTAL") {
        setConstantBudget(mbConstants?.rentBudget)
      }
      else {
        setConstantBudget(mbConstants?.buyBudget)
      }
    }, [requirement_Type]);

  const constant = async () => {
    const propertyStageValues = Object.values(constants.propertyStage);
    const propertyTypeValues = Object.values(constants.propertyType);
    setPropertyStageList(propertyStageValues);
    setPropertyTypeList(propertyTypeValues);
    const nextFollowUpValues = Object.values(constants.followUpType);
    const notIntReasonValues = Object.values(constants.notInterestedReason);
    const lostReasonValues = Object.values(constants.lostReasons);
    setnextFollowUpList(nextFollowUpValues);
    setNotIntReasonList(notIntReasonValues);
    setLostReasonList(lostReasonValues);
  };

      const [apiLocationData, setApiLocationData] = useState<any>([]);
      const [DropDownClicked, setDropDownClicked] = useState<any>([]);
      const [searchString, setSearchString] = useState<string>('');
    
    useEffect(()=>{
      const apiFunc = async()=>{
        const apiLocationData = await getLocationData(searchString,DropDownClicked)
        setApiLocationData(apiLocationData)
      }
      if((locationsList?.length===0 || projectsList?.length===0 ) && searchString !=""){
        setApiLocationData([])
        apiFunc()
      }
    },[locationsList,searchString,projectsList])

  useEffect(() => {
    if (constants) {
      constant();
    }
  }, [constants]);

  useEffect(()=>{
    organizationResources.forEach((val:any)=>{
      if(val.resource_type==="locations"){
        let loc:any=[]
        val["locations"].forEach((item:any)=>{
              loc.push(item.location)
        })
        setLocationsList(loc)
      }
      if(val.resource_type==="budgets"){
        let loc:any=[]
        val["budgets"].forEach((item:any)=>{
              loc.push(item.budget)
        })
        setBudgetsList(loc);
      }

      if(val.resource_type==="businessVertical"){
        let loc:any=[]
        val["businessVertical"].forEach((item:any)=>{
              loc.push(item.businessVertical)
        })
        setBusinessVerticalList(loc);
      }
      if(val.resource_type==="leadSources"){
        let loc:any=[]
        val["leadSources"].forEach((item:any)=>{
              loc.push(item.leadSource)
        })
        setLeadSourceList(loc);
      }

      if(val.resource_type==="comTypes"){
        let loc:any=[]
        val["comTypes"].forEach((item:any)=>{
              loc.push(item.comType)
        })
        setComTypes(loc);
      }
      if(val.resource_type==="resTypes"){
        let loc:any=[]
        val["resTypes"].forEach((item:any)=>{
              loc.push(item.resType)
        })
        setResTypes(loc);
      }
      if(val.resource_type==="industrialTypes"){
        let loc:any=[]
        val["industrialTypes"].forEach((item:any)=>{
              loc.push(item.industrialType)
        })
        setIndustrialTypes(loc);
      }
      if(val.resource_type==="institutionalTypes"){
        let loc:any=[]
        val["institutionalTypes"].forEach((item:any)=>{
              loc.push(item.institutionalType)
        })
        setInstitutionalTypes(loc);
      }

      if(val.resource_type==="states"){
        let loc:any=[]
        val["states"].forEach((item:any)=>{
              loc.push(item.state)
        })
        setStateList(loc);
      }
      
    })
  },[organizationResources])


  useEffect(() => {
    // const unsub = contactResources(
    //   contactDetail.organization_id,
    //   (data) => setLocationsList(data),
    //   (data) => setBudgetsList(data),
    //   () => {},
    //   (data) => setBusinessVerticalList(data),
    //   organizationData,
    //   () => {},
    //   (data) => setStateList(data),
    // );
    // const unsubConst = fetchConstants(
    //   (data) => setNotIntReasonList(data),
    //   (data) => setLostReasonList(data),
    //   // (data) => setPropertyStageList(data),
    //   // (data) => setPropertyTypeList(data),
    //   (data) => setnextFollowUpList(data)
    // );
    // const unSubProperty = fetchpropertySubType(
    //   contactDetail.organization_id,
    //   (data) => setComTypes(data),
    //   (data) => setResTypes(data),
    //   (data) => setLeadSourceList(data),
    //   (data) => setIndustrialTypes(data),
    //   (data) => setInstitutionalTypes(data)
    // );

    // return () => {
    //   // unsub();
    //   unsubConst();
    //   // unSubProperty();
    // };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    contactResourcesMongo(
      user.organization_id,
      (data) => setProjectsList(data),
      () => {},
      organizationData,
    )
    // eslint-disable-next-line
  }, [user.organization_id]);

  useEffect(() => {
    if (
      propertyTypeSelected.value === "Commercial"
      // || contactDetail.property_type === "Commercial"
    ) {
      if(comTypes.length === 0){
        setPropertySubType(mbConstants?.commercial);
      }
      else{
        setPropertySubType(comTypes);
      }
    } else if (
      propertyTypeSelected.value === "Residential"
      // || contactDetail.property_type === "Residential"
    ) {
      if(resTypes.length === 0){
        setPropertySubType(mbConstants?.residential);
      }
      else{
        setPropertySubType(resTypes);
      }
    }
    else if (
      propertyTypeSelected.value === "Industrial"
    ) {
      setPropertySubType(industrialTypes);
    } 
     else if (
      propertyTypeSelected.value === "Institutional"
    ) {
      setPropertySubType(institutionalTypes);
    } 
    else {
      setPropertySubType([]);
    }
  }, [propertyTypeSelected]);

  const dispatcher = useDispatch();
  const history = useHistory();
  const location: any = useLocation();

  const onSubmit = () => {
    const data = validateInterested(
      firstNameRef.current.value,
      lastNameRef.current.value,
      propertyTypeSelected.value,
      propertySubTypeSelected.value === "Select"
        ? ""
        : propertySubTypeSelected.value,
      propertyStageSelected.value,
      locationSelected.value,
      projectSelected.value,
      budgetSelected.value,
      nextFollowSelected.value,
      dateRef.current.value,
      leadSourceSelected.value === "Select"
        ? ""
        : leadSourceSelected.value,
      alternateRef.current.value,
      propertySubTypeSelected.value === "Select"
        ? ""
        : propertySubTypeSelected.value,
      dispatcher,
      organizationData.business_domain,
      businessVerticalSelected.value,
      stateSelected.value,
      organizationData.is_past_date_approval_enabled,
      organizationData.grace_past_days,
      requirement_Type.value,
      budgetSelected.label
    );
    const taskData = {
      call_back_reason: "",
      due_date: moment(dateRef.current.value).toDate(),
      type: nextFollowSelected.value,
      status: "Pending",
      customer_name:
        firstNameRef.current.value +
        " " +
        lastNameRef.current.value,
    };
    if (data != undefined) {
      if (noteRef.current.value.length !== 0) {
        // addNoteFirebase(
        //   contactDetail.contactId,
        //   notes,
        //   noteRef.current.value,
        //   () => {},
        //   dispatcher,
        //   () => {},
        //   user.user_email
        // );
        addNoteMongo(
          contactDetail.contactId,
          notes,
          noteRef.current.value,
          () => {},
          dispatcher,
          authToken,
          () => {},
          user.user_email,
          contactDetail,
          user.uid
        );
      }
      // createTaskFirebase(
      //   contactDetail.contactId,
      //   tasksData,
      //   taskData,
      //   data,
      //   (value: boolean) => setLoad(value),
      //   dispatcher,
      //   user,
      //   close,
      //   history
      // );
      createTaskMongo(
        contactDetail.contactId,
        tasksData,
        taskData,
        data,
        (value: boolean) => setLoad(value),
        dispatcher,
        user,
        close,
        history,
        authToken,
        contactDetail,
        {
          "ORGANIZATION_ID": organizationData.organization_id,
          "DISPOSITION": "Interested",
          "SUB_DISPOSITION": nextFollowSelected.value,
          "LEADID": contactDetail.contactId,
          "UID": user.uid,
          "DATE": moment(
            dateRef.current.value
          ).toISOString(),
          "PROJECT": projectSelected.value,
        }
      );

      for (let p in data) {
        let key = p;
        //@ts-ignore
        location.state.detail[`${key}`] = data[p];
      }
      location.state.detail.modified_at =
        data.modified_at;
      location.state.detail.stage_change_at =
        data.stage_change_at;
    }
  };
  const customStyles = {
    content: {
      backgroundColor:theme ? themeColors.dropdownBackgroundColor:themeColors.dropdownBackgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark
    },
  };
  // console.log("contactDetails",contactDetail)
  const containerStyles = { backgroundColor:theme ? themeColors.backgroundColor:themeColors.backgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark}
  return (
    <>
      {load === true && <Loading />}
      {open && <Backdrop>
        <motion.div
                   key="modal"
                   className="card p-4 shadow rounded"
                   style={{position: "absolute",
                   ...containerStyles}}
                   variants={dropIn}
                   initial="hidden"
                   animate="visible"
                   exit="exit"
                 >
        <div className={styles.firstDiv}>
          {/* <p className={styles.contactForm}>
            Interested Details
          </p> */}
          <h5>Interested Details</h5>
          <div className={styles.cross} onClick={close}>
            <IoIosClose size={35} color={"#808080"} />
          </div>
        </div>
        <div className={styles.line}></div>
        
        <div style={{maxHeight: "400px",overflowY:"auto"}}>

          
        <div className={styles.box2}>
          <div className={styles.divide}>
            {/* <div className={styles.title}>
              <p className={styles.one}>First Name</p>
              <p className={styles.two}>*</p>
            </div> */}
            <Label label="First Name" required={true} />
            <div>
              <TextInput
                title={"Enter first name"}
                style={{ backgroundColor: "#fff" }}
                ref={firstNameRef}
                value={contactDetail.customer_name
                  .split(" ")[0]
                  .trim()}
              >
                <FaUser color={"#808080"} />
              </TextInput>
            </div>
          </div>

          <div className={styles.divide}>
            {/* <div className={styles.title}>
              <p className={styles.one}>Last Name</p>
              <p className={styles.two}>*</p>
            </div> */}
            <Label label="Last Name" required={true} />
            <div>
              <TextInput
                title={"Enter last name"}
                style={{ backgroundColor: "#fff" }}
                ref={lastNameRef}
                value={contactDetail.customer_name
                  .slice(
                    contactDetail.customer_name.split(
                      " "
                    )[0].length
                  )
                  .trim()}
              >
                <FaUser color={"#808080"} />
              </TextInput>
            </div>
          </div>
        </div>

        <div className={styles.box2}>
          <div className={styles.divide}>
            {/* <div className={styles.title}>
              <p className={styles.one}>Location</p>
              <p className={styles.two}>*</p>
            </div> */}
            <Label label="Location" required={true} />
            <div 
            style={{ marginTop: "7px" }}
            >
              <Dropdown
                option={locationsList?.length === 0?apiLocationData:locationsList}
                selectedValue={locationSelected}
                setSelectedValue={(value) => {
                  setlocationSelected(value);
                }}
                placeholder='Location'
                isAutoSuggestionDropdown={true}
                searchString={(value) => {
                  setDropDownClicked("LOCATION")
                  setSearchString(value);
                }}
                setApiLocationData={()=>{
                  setApiLocationData([])
                }}
              />
            </div>
          </div>
          <div className={styles.divide}>
            {/* <div className={styles.title}>
              <p className={styles.one}>Location</p>
              <p className={styles.two}>*</p>
            </div> */}
            <Label label="Lead State" required={true} />
            <div 
            style={{ marginTop: "7px" }}
            >
              <Dropdown
                option={stateList.length===0?mbConstants.states:stateList}
                selectedValue={stateSelected}
                setSelectedValue={(value) => {
                  setStateSelected(value);
                }}
              />
            </div>
          </div>
        </div>

        <div className={styles.box2}>
          <div className={styles.divide}>
              <Label label="Requirement Type" required={true} />
              <div style={{ marginTop: "7px" }}>
                <Dropdown
                  option={Requirement}
                  selectedValue={requirement_Type}
                  setSelectedValue={(value) => {
                    setRequirement_Type(value);
                    setBudgetSelected({
                      label: "Select",
                      value: "Select",
                    })
                  }}
                />
              </div>  
            </div>

          <div className={styles.divide}>
            <Label label="Budget" required={true} />
            <div style={{ marginTop: "7px" }}>
                 {budgetsList.length===0?                
                <DropDownWithDisplayName
                  option={constantBudget}
                  selectedValue={budgetSelected}
                  setSelectedValue={(value) => {
                    setBudgetSelected(value);
                  }}
                />:
                <Dropdown
                option={budgetsList}
                selectedValue={budgetSelected}
                setSelectedValue={(value) => {
                  setBudgetSelected(value);
                }}
              />}
            </div>
          </div>
        </div>

        <div className={styles.box2}>
          {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")&&
          <div className={styles.divide}>
            {/* <div className={styles.title}>
              <p className={styles.one}>Property Type</p>
              <p className={styles.two}>*</p>
            </div> */}
            {(!contactDetail.requirement_Type || requirement_Type.value === "NEW PROJECT") ?
            <Label label="Property Type" required={true} />
            :
            <Label label="Property Type" required={false} />}
            <div style={{ marginTop: "7px" }}>
              <Dropdown
                option={propertyTypeList}
                selectedValue={propertyTypeSelected}
                setSelectedValue={(value) => {
                  setPropertyTypeSelected(value);
                  setPropertySubTypeSelected("Select");
                }}
              />
            </div>
          </div>}
          {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")&&
          <div className={styles.divide}>
            {(!contactDetail.requirement_Type || requirement_Type.value === "NEW PROJECT") ?
            <Label label="Property Stage" required={true} />
            :
            <Label label="Property Stage" required={false} />}
            <div style={{ marginTop: "7px" }}>
              <Dropdown
                option={propertyStageList}
                selectedValue={propertyStageSelected}
                setSelectedValue={(value) => {
                  setPropertyStageSelected(value);
                }}
              />
            </div>
          </div>}
        </div>

        <div className={styles.box2}>
        <div className={styles.divide} style={{width: "100%"}}>
            {(!contactDetail.requirement_Type || requirement_Type.value === "NEW PROJECT") ?
            <Label label="Project" required={true} />
            :
            <Label label="Project" required={false} />}
            <div style={{ marginTop: "7px" }}>
              <Dropdown
                option={projectsList?.length === 0?apiLocationData:projectsList}
                selectedValue={projectSelected}
                setSelectedValue={(value) => {
                  setProjectSelected(value);
                }}
                placeholder='Project'
                isAutoSuggestionDropdown={true}
                searchString={(value) => {
                  setDropDownClicked("PROJECT")
                  setSearchString(value);
                }}
                setApiLocationData={()=>{
                  setApiLocationData([])
                }}
              />
            </div>
          </div>
        </div>

        <div className={styles.box2}>
        <div className={styles.divide}>
            <Label label="Next Follow Up Type" required={true} />
            <div style={{ marginTop: "7px" }}>
              <Dropdown
                option={nextFollowUpList}
                selectedValue={nextFollowSelected}
                setSelectedValue={(value) => {
                  setNextFollowSelected(value);
                }}
              />
            </div>
          </div>
          <div className={styles.divide}>
            <Label label="Next Follow Up On" required={true} />
            <div>
              <input
                type="datetime-local"
                placeholder="Enter Date"
                ref={dateRef}
                className={styles.dateInput}
              />
            </div>
          </div>
          {(organizationData.business_domain && organizationData.business_domain !== "Real Estate")&&(
                          <div className={styles.divide}>
                          <Label label="Business Vertical" required={true} />
                          <Dropdown
                              option={businessVerticalList}
                              selectedValue={businessVerticalSelected}
                              setSelectedValue={(value) => {
                                setBusinessVerticalSelected(value);
                              }}
                            />
                        </div>
            )}

        </div>

        <div className={styles.box2}>
          <div className={styles.divide}>
            {/* <div className={styles.title}>
              <p className={styles.one}>Lead Source</p>
              <p className={styles.two}>*</p>
            </div> */}
            <Label label="Lead Source" required={true} />
            <div style={{ marginTop: "7px" }}>
              <Dropdown
                option={leadSourceList}
                selectedValue={leadSourceSelected}
                setSelectedValue={(value) => {
                  setLeadSourceSelected(value);
                }}
              />
            </div>
          </div>
          <div className={styles.divide}>
            {/* <div className={styles.title}>
              <p className={styles.one}>Alternate No.</p>
              <p className={styles.two}></p>
            </div> */}
            <Label label="Alternate Number" required={false} />
            <div>
              <TextInput
                title={"Enter Alternate Number"}
                style={{ backgroundColor: "#fff" }}
                ref={alternateRef}
                value={contactDetail.alternate_no}
                length={true}
              ></TextInput>
            </div>
          </div>
        </div>

        <div className={styles.box2}>
        <div className={styles.divide}>
            {/* <div className={styles.title}>
              <p className={styles.one}>Note</p>
              <p className={styles.two}></p>
            </div> */}
            <Label label="Note" required={false} />
            <div>
              <TextInput
                title={"Enter Note"}
                style={{ backgroundColor: "#fff" }}
                ref={noteRef}
              ></TextInput>
            </div>
          </div>
          {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")&&
        <div className={styles.divide}>
            <Label label="Property Sub Type" required={false} />
            <div style={{ marginTop: "7px" }}>
              <Dropdown
                option={propertySubType}
                selectedValue={propertySubTypeSelected}
                setSelectedValue={(value) => {
                  setPropertySubTypeSelected(value);
                }}
              />
            </div>
          </div>}
        </div>
        </div>

        <button
          className={styles.apply}
          style={{ marginTop: "2rem" }}
          onClick={onSubmit}
        >
          Save
        </button>
                 </motion.div>
        </Backdrop>}
      {/* <Modal
        className={styles.parent}
        isOpen={open}
        shouldCloseOnOverlayClick={true}
        overlayClassName={styles.overlay}
        shouldCloseOnEsc={true}
        onRequestClose={close}
        style={customStyles}
      >
        <div className={styles.firstDiv}> */}
          {/* <p className={styles.contactForm}>
            Interested Details
          </p> */}
          {/* <h5>Interested Details</h5>
          <div className={styles.cross} onClick={close}>
            <IoIosClose size={35} color={"#808080"} />
          </div>
        </div>
        <div className={styles.line}></div>

        <div className={styles.box2}>
          <div className={styles.divide}> */}
            {/* <div className={styles.title}>
              <p className={styles.one}>First Name</p>
              <p className={styles.two}>*</p>
            </div> */}
            {/* <Label label="First Name" required={true} />
            <div>
              <TextInput
                title={"Enter first name"}
                style={{ backgroundColor: "#fff" }}
                ref={firstNameRef}
                value={contactDetail.customer_name
                  .split(" ")[0]
                  .trim()}
              >
                <FaUser color={"#808080"} />
              </TextInput>
            </div>
          </div>

          <div className={styles.divide}> */}
            {/* <div className={styles.title}>
              <p className={styles.one}>Last Name</p>
              <p className={styles.two}>*</p>
            </div> */}
            {/* <Label label="Last Name" required={true} />
            <div>
              <TextInput
                title={"Enter last name"}
                style={{ backgroundColor: "#fff" }}
                ref={lastNameRef}
                value={contactDetail.customer_name
                  .slice(
                    contactDetail.customer_name.split(
                      " "
                    )[0].length
                  )
                  .trim()}
              >
                <FaUser color={"#808080"} />
              </TextInput>
            </div>
          </div>
        </div>

        <div className={styles.box2}>
          <div className={styles.divide}> */}
            {/* <div className={styles.title}>
              <p className={styles.one}>Location</p>
              <p className={styles.two}>*</p>
            </div> */}
            {/* <Label label="Location" required={true} />
            <div 
            style={{ marginTop: "7px" }}
            >
              <Dropdown
                option={locationsList}
                selectedValue={locationSelected}
                setSelectedValue={(value) => {
                  setlocationSelected(value);
                }}
              />
            </div>
          </div>
          <div className={styles.divide}> */}
            {/* <div className={styles.title}>
              <p className={styles.one}>Project</p>
              <p className={styles.two}>*</p>
            </div> */}
            {/* <Label label="Project" required={true} />
            <div style={{ marginTop: "7px" }}>
              <Dropdown
                option={projectsList}
                selectedValue={projectSelected}
                setSelectedValue={(value) => {
                  setProjectSelected(value);
                }}
              />
            </div>
          </div>
        </div>

        <div className={styles.box2}>
          <div className={styles.divide}> */}
            {/* <div className={styles.title}>
              <p className={styles.one}>
                Next Follow Up Type
              </p>
              <p className={styles.two}>*</p>
            </div> */}
            {/* <Label label="Next Follow Up Type" required={true} />
            <div style={{ marginTop: "7px" }}>
              <Dropdown
                option={nextFollowUpList}
                selectedValue={nextFollowSelected}
                setSelectedValue={(value) => {
                  setNextFollowSelected(value);
                }}
              />
            </div>
          </div>

          <div className={styles.divide}> */}
            {/* <div className={styles.title}>
              <p className={styles.one}>Budget</p>
              <p className={styles.two}>*</p>
            </div> */}
            {/* <Label label="Budget" required={true} />
            <div style={{ marginTop: "7px" }}>
              <Dropdown
                option={budgetsList}
                selectedValue={budgetSelected}
                setSelectedValue={(value) => {
                  setBudgetSelected(value);
                }}
              />
            </div>
          </div>
        </div>

        <div className={styles.box2}>
          <div className={styles.divide}> */}
            {/* <div className={styles.title}>
              <p className={styles.one}>Property Type</p>
              <p className={styles.two}>*</p>
            </div> */}
            {/* <Label label="Property Type" required={true} />
            <div style={{ marginTop: "7px" }}>
              <Dropdown
                option={propertyTypeList}
                selectedValue={propertyTypeSelected}
                setSelectedValue={(value) => {
                  setPropertyTypeSelected(value);
                }}
              />
            </div>
          </div>
          <div className={styles.divide}> */}
            {/* <div className={styles.title}>
              <p className={styles.one}>Property Stage</p>
              <p className={styles.two}>*</p>
            </div> */}
            {/* <Label label="Property Stage" required={true} />
            <div style={{ marginTop: "7px" }}>
              <Dropdown
                option={propertyStageList}
                selectedValue={propertyStageSelected}
                setSelectedValue={(value) => {
                  setPropertyStageSelected(value);
                }}
              />
            </div>
          </div>
        </div>

        <div className={styles.box2}>
          <div className={styles.divide}> */}
            {/* <div className={styles.title}>
              <p className={styles.one}>
                Next Follow Up Date & Time
              </p>
              <p className={styles.two}>*</p>
            </div> */}
            {/* <Label label="Next Follow Up Date & Time" required={true} />
            <div>
              <input
                type="datetime-local"
                placeholder="Enter Date"
                ref={dateRef}
                className={styles.dateInput}
              />
            </div>
          </div>

          <div className={styles.divide}> */}
            {/* <div className={styles.title}>
              <p className={styles.one}>Note</p>
              <p className={styles.two}></p>
            </div> */}
            {/* <Label label="Note" required={false} />
            <div>
              <TextInput
                title={"Enter Note"}
                style={{ backgroundColor: "#fff" }}
                ref={noteRef}
              ></TextInput>
            </div>
          </div>
        </div>

        <div className={styles.box2}>
          <div className={styles.divide}> */}
            {/* <div className={styles.title}>
              <p className={styles.one}>
                Property Sub Type
              </p>
              <p className={styles.two}></p>
            </div> */}
            {/* <Label label="Property Sub Type" required={true} />
            <div style={{ marginTop: "7px" }}>
              <Dropdown
                option={propertySubType}
                selectedValue={propertySubTypeSelected}
                setSelectedValue={(value) => {
                  setPropertySubTypeSelected(value);
                }}
              />
            </div>
          </div>
          <div className={styles.divide}> */}
            {/* <div className={styles.title}>
              <p className={styles.one}>Lead Source</p>
              <p className={styles.two}>*</p>
            </div> */}
            {/* <Label label="Lead Source" required={true} />
            <div style={{ marginTop: "7px" }}>
              <Dropdown
                option={leadSourceList}
                selectedValue={leadSourceSelected}
                setSelectedValue={(value) => {
                  setLeadSourceSelected(value);
                }}
              />
            </div>
          </div>
        </div>

        <div className={styles.box2}>
          <div className={styles.divide}> */}
            {/* <div className={styles.title}>
              <p className={styles.one}>Alternate No.</p>
              <p className={styles.two}></p>
            </div> */}
            {/* <Label label="Alternate No." required={false} />
            <div>
              <TextInput
                title={"Enter Alternate Number"}
                style={{ backgroundColor: "#fff" }}
                ref={alternateRef}
                value={contactDetail.alternate_no}
                length={true}
              ></TextInput>
            </div>
          </div>
        </div>

        <button
          className={styles.apply}
          style={{ marginTop: "2rem" }}
          onClick={onSubmit}
        >
          Save
        </button> */}
      {/* </Modal> */}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode,
    authToken:state.user.authToken,
    organizationData: state.organization.organizationData,
    constants:state.constants.data,
    organizationResources:state.organizationResources.data,
    mbConstants:state?.mbConstant?.data
  };
};
export default connect(mapStateToProps)(
  InterestedLeadModal
);
